import { Action, createReducer, on } from '@ngrx/store';
import { d365AccountContactDataToCustomerContact } from '../../common/functions/transformation.functions';
import { GeolocationMonitoring } from '../../common/models/user/geolocation-monitoring';
import * as ua from '../actions/user.actions';
import { DataOwnershipChange, UserState } from '../models/user-state';

export const initialState: UserState = {
    contact: null,
    lead: null,
    agentInfo: null,
    customerInfo: null,
    fromCrm: null,
    cartSegment: null,
    customerMastership: null,
    dataOwnershipChange: new DataOwnershipChange(),
    geolocationMonitoring: new GeolocationMonitoring()
};

const reducer = createReducer(
    initialState,
    on(ua.setUserState, (state, { s }) => ({
        ...s,
        agentInfo: state.agentInfo
    })),
    on(ua.setContact, (state, { c, fcrm }) => ({
        ...state,
        contact: c,
        fromCrm: fcrm ? fcrm : state.fromCrm
    })),
    on(ua.setContactEmail, (state, { email }) => ({
        ...state,
        contact: {
            ...state.contact,
            emailaddress1: email
        }
    })),
    on(ua.setLead, (state, { l, fcrm }) => ({
        ...state,
        lead: l,
        fromCrm: fcrm ? fcrm : state.fromCrm
    })),
    on(ua.setAgentInfo, (state, { a }) => ({
        ...state,
        agentInfo: a
    })),
    on(ua.setCustomerInfo, (state, { c }) => ({
        ...state,
        customerInfo: c
    })),
    on(ua.resetUserState, (state) => ({
        ...state,
        contact: null,
        lead: null,
        fromCrm: false,
        customerInfo: null,
        customerMastership: undefined,
        dataOwnershipChange: new DataOwnershipChange(),
        geolocationMonitoring: new GeolocationMonitoring()
    })),

    on(ua.setLastUsedCustomerSegment, (state, { s }) => ({
        ...state,
        agentInfo: {
            ...state.agentInfo,
            UserConfiguration: {
                ...state.agentInfo.UserConfiguration,
                LastUsedCustomerSegment: s
            }
        }
    })),
    on(ua.setCartSegment, (state, { payload }) => ({
        ...state,
        cartSegment: payload
    })),
    on(ua.setVirtualAgentAgencyCurrentBranch, (state, { payload }) => {
        state.agentInfo.VirtualAgents.forEach((va) => {
            if (va.IsCurrentSelected) {
                va.CurrentAgencyBranch = payload;
            }
        });
        return { ...state };
    }),
    on(ua.setCustomerMastership, (state, { customerMastership }) => ({
        ...state,
        customerMastership
    })),
    on(ua.setCustomerAndContact, (state, { customer }) => ({
        ...state,
        ...d365AccountContactDataToCustomerContact(customer)
    })),
    on(ua.setDataOwnershipChangeState, (state, { newState }) => {
        const dataOwnershipChange = { ...state.dataOwnershipChange } || new DataOwnershipChange();
        dataOwnershipChange.currentState = newState;

        return { ...state, dataOwnershipChange: dataOwnershipChange };
    }),
    on(ua.setDataOwnershipChangeData, (state, { data }) => {
        const dataOwnershipChange = { ...state.dataOwnershipChange } || new DataOwnershipChange();
        dataOwnershipChange.data = data;

        return { ...state, dataOwnershipChange: dataOwnershipChange };
    }),
    on(ua.setDataGeolocationMonitoring, (state, { geolocationMonitoring }) => ({
        ...state,
        geolocationMonitoring
    }))
);

export function userReducer(state: UserState | undefined, action: Action): UserState {
    return reducer(state, action);
}
